// extracted by mini-css-extract-plugin
export default {"templateItem":"TemplateItem_templateItem__yXFfg","mouseContainer":"TemplateItem_mouseContainer__A2jdy"};